export default "__VITE_ASSET__BL0XzzGa__"